import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "@/hooks/useAuth";
import BookingsPanel from "@/components/BookingsPanel/BookingsPanel";
import HostCompanyGate from "@/components/HostCompanyGate/HostCompanyGate";
import "@/pages/HomePage/HomePage.scss";

function HomePage() {
  const { t } = useTranslation();
  const { session } = useAuth();

  return (
    <div className="home-page">
      <section className="home-page__intro">
        <h1>{t("home.title")}</h1>
        <p>{t("home.welcome", { email: session?.email })}</p>
        <div className="home-page__links">
          <Link to="/properties/new">{t("home.addPropertyLink")}</Link>
          <Link to="/my-properties">{t("home.propertiesLink")}</Link>
          <Link to="/my-bookings">{t("home.bookingsLink")}</Link>
        </div>
      </section>

      <section className="home-page__bookings">
        <HostCompanyGate>
          {(companyId) => <BookingsPanel companyId={companyId} />}
        </HostCompanyGate>
      </section>
    </div>
  );
}

export default HomePage;
